import React, { Component } from 'react';
import './AirDrawer.css';
import { CloseIcon } from '../../icons';
import { Drawer } from 'antd';
import AirButton from '../AirButton';

import { observer } from 'mobx-react';

@observer
export default class AirDrawer extends Component {
  render() {

    return (
      <Drawer
        className={`AirDrawer ${this.props.className || ''}`}
        closable={false}
        style={this.props.style}
        zIndex={this.props.zIndex}
        onClose={this.props.onClose}
        width={this.props.width}
        height={this.props.height}
        visible={this.props.visible}
      >
        <div className="header">
          <div className="title">{this.props.title}</div>
          <div className="close">
            <CloseIcon onClick={this.props.onClose} />
          </div>
        </div>
        <div className="content">{this.props.children}</div>
        <div className="buttons">
          <AirButton className={this.props.disabled === true ? 'okButton disabled' : 'okButton'} light size="large" disabled={this.props.disabled} label={this.props.okLabel} onClick={this.props.onOk} />
          <AirButton className="cancelButton" size="large" label={this.props.cancelLabel} onClick={this.props.onCancel} />
        </div>
      </Drawer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirDrawer/AirDrawer.js